import gql from 'graphql-tag'
import { Component } from 'react'
import { graphql } from '@apollo/client/react/hoc'
import { UserQuery } from '../Functions/querys'
import SideBar from "./Sidebar.js"
import { PreferredDateTimeProvider } from '../Context/PreferredDateTimeContext'
import withApolloClient from '../withApolloClient'
import { CurrentUserProvider } from '../Context/CurrentUserContext.js'
import '../App.css'
import Content from "./Content.js"
import Header from './Header.js'
import { loginToFirebaseWithToken } from '../Components/firebase.js'

const UpdateMember = gql`
    mutation updateMember($input: UpdateMemberMutationInput!){
        updateMember(input:$input){
        ok
        errors{
            messages
            field
        }
    }
}`

const GenerateUserJwtToken = gql`
    mutation generateUserJwtToken($input: GenerateUserJwtTokenInput!){
        generateUserJwtToken(input:$input){
        ok token
        errors{ messages field }
    }
}`

class Layout extends Component {
    constructor(props) {
        super(props)
        this.state = {
            showLeftNav: true,
            loading: false,
            keyVersion: 1,
            preferredDateTimeInfo: {
                dateFormat: "MMM D, YYYY",
                timeFormat: "h:mm A",
                timezone: "America/New_York"

            }
        }
    }

    generateUserTokenAndLoginToFirebase = (userId) => {
        if (userId) {
            this.props.apolloClient.mutate({
                mutation: GenerateUserJwtToken,
                variables: { input: { userId } },
            }).then((result) => {
                if (result.data && result.data.generateUserJwtToken && result.data.generateUserJwtToken.ok) {
                    const token = result.data.generateUserJwtToken.token
                    // Use the token to authenticate with Firebase or perform other actions as needed
                    loginToFirebaseWithToken(token).then(() => {
                        console.log("Logged in to Firebase with custom token")
                    }).catch((error) => {
                        console.error("Error logging in to Firebase with custom token:", error)
                    })
                } else {
                    console.error("Failed to generate JWT token")
                }
            }).catch((error) => {
                console.error("Error generating JWT token:", error)
            })
        } else {
            console.log("No user ID provided, skipping JWT generation.")
        }
    }

    componentDidUpdate(prevProps) {
        if (
            this.props.currentUser?.member &&
            (
                prevProps.currentUser?.member?.preferredTimeFormat !== this.props.currentUser.member.preferredTimeFormat ||
                prevProps.currentUser?.member?.preferredTimezone !== this.props.currentUser.member.preferredTimezone ||
                prevProps.currentUser?.member?.preferredDateFormat !== this.props.currentUser.member.preferredDateFormat
            )
        ) {
            const preferredDateTimeInfo = {
                timeFormat: this.props.currentUser.member.preferredTimeFormat || this.state.preferredDateTimeInfo.timeFormat,
                timezone: this.props.currentUser.member.preferredTimezone || this.state.preferredDateTimeInfo.timezone,
                dateFormat: this.props.currentUser.member.preferredDateFormat || this.state.preferredDateTimeInfo.dateFormat,
            }
            this.setState({ preferredDateTimeInfo })
        }

        // If the user changes/ logs in, generate a new JWT token and login to firebase with that token
        if (prevProps.currentUser?.id !== this.props.currentUser?.id) {
            this.generateUserTokenAndLoginToFirebase(this.props.currentUser?.id)
        }

    }

    updatePreferredDateTimeInfo = (itemName, value) => {
        let name = "preferred" + itemName.charAt(0).toUpperCase() + itemName.slice(1)
        this.setState({ preferredDateTimeInfo: { ...this.state.preferredDateTimeInfo, [itemName]: value } })
        this.updateSelectedInfo(this.props.currentUser.member.id, name, value)
    }

    updateSelectedInfo = (memberId, name, value) => {
        try {
            this.setState({ loading: true })
            let input = { memberId, [name]: value }

            this.props.apolloClient.mutate({
                mutation: UpdateMember,
                variables: { input },
            }).then((result) => {
                this.setState({ loading: false })
                if (result.data && result.data.updateMember && result.data.updateMember.ok) {
                    this.props.refetchUserQuery()
                    this.setState({ loading: false, keyVersion: this.state.keyVersion + 1 })
                } else {
                    this.setState({ loading: false })
                }
            }).catch((error) => {
                let errorMessage = "An error has occurred"
                this.setState({ error: errorMessage, loading: false })
            })
        } catch (err) {
            let errorMessage = "An error has occurred"
            this.setState({ error: errorMessage, loading: false })
        }
    };

    render() {
        return (<>
            <CurrentUserProvider currentUser={this.props.currentUser} setCurrentUser={this.props.setCurrentUser}>
                <SideBar showLeftNav={this.state.showLeftNav} updateShowLeftNav={() => this.setState({ showLeftNav: !this.state.showLeftNav })} />
                <PreferredDateTimeProvider preferredDateTimeInfo={this.state.preferredDateTimeInfo} setPreferredDateTimeInfo={this.updatePreferredDateTimeInfo}>
                    <div className={"mainContent " + (this.state.showLeftNav ? "" : "full-width")}>
                        <Header keyVersion={this.state.keyVersion} setKeyVersion={(keyVersion) => this.setState({ keyVersion })} />
                        <Content key={String(this.state.keyVersion)} />
                    </div>
                </PreferredDateTimeProvider>
            </CurrentUserProvider>
        </>
        )
    }
}

//-----------------------------------
export default graphql(UserQuery, {
    props: ({ data: { currentUser, refetch, loading } }) => ({
        currentUser,
        currentUserLoading: loading,
        refetchUserQuery: () => {
            return refetch({
                query: UserQuery,
                updateQuery: (previousResult, { fetchMoreResult }) => {
                    return { currentUser: fetchMoreResult.currentUser }
                }
            })
        }
    })
})(withApolloClient(Layout))
